/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'myspace': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#507fa7" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M21.912 13.162a4.866 4.866 0 00-3.705 1.707 4.033 4.033 0 00-3.703-2.434 4.02 4.02 0 00-3.168 1.54 3.125 3.125 0 00-6.126.872v5.209h5.262v3.134h6.563v2.98h9.755v-8.129a4.878 4.878 0 00-4.878-4.878z"/><path pid="2" _fill="#fff" d="M25.371 9.26a3.429 3.429 0 11-6.857 0 3.429 3.429 0 016.857 0zM17.364 9.209a2.835 2.835 0 11-5.67 0 2.835 2.835 0 015.67 0zM10.551 9.222a2.197 2.197 0 11-4.395 0 2.197 2.197 0 014.395 0z"/>'
  }
})
